import * as React from 'react';
import * as style from './PromoCompilationItemLayout.css';

export const PromoCompilationItemLayout: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return <div className={style['item']}>{children}</div>;
};
